import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=57925132&scoped=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdminDashboard.vue?vue&type=style&index=0&id=57925132&prod&lang=scss"
import style1 from "./AdminDashboard.vue?vue&type=style&index=1&id=57925132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57925132",
  null
  
)

export default component.exports